import Splide from '@splidejs/splide';

( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.map-mobile-slider.splide' ).length ) {
        const mapSliders = [];

        $( '.map-mobile-slider.splide' ).each( function( index, element ) {
          const slider = new Splide( element, {
            type: 'slide',
            perPage: 1,
            perMove: 1,
            gap: '32px',
            padding: '32px',
            arrows: false,
            pagination: false,
            drag: true,
            speed: 400,
          } );

          slider.mount();
          mapSliders.push( slider );

          const firstButton = $( '.map-pin-button[data-slide-index="0"]' );
          if ( firstButton.length ) {
            firstButton.addClass( 'is-active' );
          }

          // Sync slider with map pin buttons
          slider.on( 'moved', function( newIndex, prevIndex, destIndex ) {
            $( '.map-pin-button[data-toggle-radio-group="project-maps"]' ).removeClass( 'is-active' );

            const activeButton = $( `.map-pin-button[data-slide-index="${destIndex}"]` );
            if ( activeButton.length ) {
              activeButton.addClass( 'is-active' );
            }
          } );
        } );

        $( '.map-pin-button' ).on( 'click', function( e ) {
          if ( $( '.map-mobile-slider' ).is( ':visible' ) ) {
            const slideIndex = parseInt( $( this ).data( 'slide-index' ), 10 );
            if ( !isNaN( slideIndex ) && mapSliders.length > 0 ) {
              mapSliders[0].go( slideIndex );
              e.stopImmediatePropagation();
              return false;
            }
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'map', COMPONENT );
} )( app );
